import { render, staticRenderFns } from "./SelfPlayer.vue?vue&type=template&id=573dca1f&"
import script from "./SelfPlayer.vue?vue&type=script&lang=js&"
export * from "./SelfPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SelfPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports